'use client';
import clsx from 'clsx';
import { useIsMounted } from '../../../hooks/useIsMounted';
import { useDropdownContext } from '../../DropdownProvider';
import { TOGGLE_SEARCH_ACTION } from '../../DropdownProvider/useSingleDropdown';
import { FullscreenOverlay } from '../../FullscreenOverlay';
import { MagnifyingGlass } from '../../Icons/MagnifyingGlass';
import { useSatelliteContext } from '../../SatelliteProvider';
import { CloseButton } from '../../CloseButton';
import { SearchInput } from './SearchInput';

export function SearchDropdownToggle() {
  const {
    headerOptions: { enableSearch },
  } = useSatelliteContext();
  const { state, dispatch } = useDropdownContext();
  const mounted = useIsMounted();

  if (!enableSearch || !mounted) {
    return null;
  }

  const handleClick = () => {
    dispatch(TOGGLE_SEARCH_ACTION);
  };

  const handleCloseOverlay = () => {
    dispatch(TOGGLE_SEARCH_ACTION);
  };

  return (
    <div
      className={clsx(
        'flex',
        'items-center',
        'justify-center',
        'bg-transparent',
        'border-0',
        'focus:outline-2',
        'focus:outline-offset-4',
      )}
    >
      <FullscreenOverlay isOpen={state.isShowingSearch} onClick={handleCloseOverlay} />
      <button
        onClick={handleClick}
        aria-label={state.isShowingSearch ? 'Close search menu' : 'Open search menu'}
        aria-expanded={state.isShowingSearch}
        aria-controls="satellite-search-menu"
        aria-haspopup="dialog"
        className={clsx(
          'flex',
          'items-center',
          'justify-center',
          'h-[49px]',
          'w-[49px]',
          'cursor-pointer',
          'rounded-full',
          'hover:text-green-dark',
          'hover:bg-neutral-lightest',
          'focus:text-green-dark',
          'focus:bg-green-lightest',
          'active:bg-green-lightest',
          'active:text-green-dark',
          {
            'bg-green-lightest': state.isShowingSearch,
            'text-green-dark': state.isShowingSearch,
          },
        )}
      >
        <MagnifyingGlass width={20} height={20} />
      </button>
      {state.isShowingSearch && (
        <div
          id="satellite-search-menu"
          role="dialog"
          className={clsx(
            'flex',
            'top-[var(--satellite-header-height)]',
            'absolute',
            'bg-white',
            'right-0',
            'left-0',
            'top-[var(--satellite-header-height)]',
            'max-h-[17.5rem]',
          )}
        >
          <div className={clsx('mx-4', 'mt-16', 'lg:mx-[12.5rem]', 'my-10', 'w-full')}>
            <SearchInput baseUri="https://www.nerdwallet.com" />
          </div>
          <CloseButton onClick={handleCloseOverlay} />
        </div>
      )}
    </div>
  );
}
